import { isFeatureEnabled } from 'owa-feature-flags';

// There are a few environments where 3S is not available
// and attachment suggestions will not work there
// suggestion will not be enabled in those environments
export function attachmentSuggestionsEnabled(): boolean {
    return !isFeatureEnabled('doc-suppressAttachmentSuggestions');
}
